import $ from 'jquery'

export const renderHeaderBlock = () => {
  setTimeout(() => {

    const currency = $('.menu-item-cash .current-currency')
    const currencyDrop = $('.menu-item-cash .drop')
    const lang = $('.menu-item-cash_lang .current-state')
    const langDrop = $('.menu-item-cash_lang .drop')
    const account = $('.account-login-link .btn-account')
    const accountDrop = $('.account-login-link .account-dropdown')
    const btnClose = $('.menu-item-cash .btn-close, .menu-item-cash_lang .btn-close, .account-login-link .btn-close')
    const body = $('body')

    currency.on('click keydown', function (e) {
      if (
        e.type === "keydown" &&
        e.key !== "Enter" &&
        e.key !== " "
      ) {
        return;
      }
      $(this).parent('div').toggleClass('active')
      body.toggleClass('switcheropened')
    })

    lang.on('click keydown', function (e) {
      if (
        e.type === "keydown" &&
        e.key !== "Enter" &&
        e.key !== " "
      ) {
        return;
      }
      $(this).parent('div').toggleClass('active')
      body.toggleClass('switcheropened')
    })

    account.on('click keydown', function (e) {
      if (
        e.type === "keydown" &&
        e.key !== "Enter" &&
        e.key !== " "
      ) {
        return;
      }
      $(this).parent('.account-login-link').toggleClass('active')
      body.toggleClass('switcheropened')
    })

    btnClose.on('click keydown', function (e) {
      if (
        e.type === "keydown" &&
        e.key !== "Enter" &&
        e.key !== " "
      ) {
        return;
      }
      currency.parent('div').removeClass('active')
      lang.parent('div').removeClass('active')
      account.parent('div').removeClass('active')
      body.removeClass('switcheropened')
    })

    const clickOutside = () => {
      const windowWidth = $(window).width()
      if (windowWidth > 1023) {
        $(document).on('click', (e) => {
          if (!$(e.target).closest(currency).length && !$(e.target).closest(currencyDrop).length) {
            currency.parent('div').removeClass('active')
          }
          if (!$(e.target).closest(lang).length && !$(e.target).closest(langDrop).length) {
            lang.parent('div').removeClass('active')
          }
          if (!$(e.target).closest(account).length && !$(e.target).closest(accountDrop).length) {
            account.parent('div').removeClass('active')
          }
          e.stopPropagation()
        })
      }
    }

    clickOutside()

    $(window).resize(() => {
      clickOutside()
    })

  }, 900);
}

$(document).ready(() => {
  // const lazySearchBox = $('.search-sticky');
  // $('.search-widget .search-home__loader').hide();
  $('.search-box-loader').hide();

  $('.magazine-header__burger').click(function() {
    $('.magazine-header__menu-collapsed').toggleClass('magazine-header__menu-expanded')
    $('body').toggleClass('no-scroll')
  })
});
